<template>
  <div class="emn-loader-container">
    <div class="emn-loader"></div>
  </div>
</template>

<script setup lang="ts">
// Component logic can be added here if needed
</script>

<style scoped>
@import './emnLoader.css';
</style>
